import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Button } from "hesus-ui-kit";
import ClipLoader from "react-spinners/ClipLoader";
import { ButtonWrapper } from "./QuoteView.styled";

const ValidateButton = (props) => {
  const { t, type, isServiceValidating, onValidateServiceButton } = props;

  return (
    <>
      {type === "green" && (
        <ButtonWrapper content="flex-end;">
          <Button
            styles={{
              color: "#fff",
              background: "green",
              padding: "0.25rem 0.875rem",
              border: "1px solid green",
              "&:hover": {
                backgroundColor: "green",
              },
            }}
            onClick={onValidateServiceButton}
          >
            <>
              {isServiceValidating && <ClipLoader size={15} color="#fff" />}
              {!isServiceValidating && t("VALIDATE")}
            </>
          </Button>
        </ButtonWrapper>
      )}

      {type === "gray" && (
        <Button
          styles={{
            color: "#fff",
            background: "gray",
            padding: "0.25rem 0.875rem",
            border: "1px solid gray",
            "&:hover": {
              backgroundColor: "gray",
            },
          }}
          onClick={onValidateServiceButton}
        >
          <>
            {isServiceValidating && <ClipLoader size={15} color="#fff" />}
            {!isServiceValidating && t("VALIDATE")}
          </>
        </Button>
      )}
    </>
  );
};

ValidateButton.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ValidateButton);
